// Import all language versions from language folders
import QueHacerEnTigreEn from './en/que-hacer-en-tigre.md';
import QueHacerEnTigreEs from './es/que-hacer-en-tigre.md';
import QueHacerEnTigreDe from './de/que-hacer-en-tigre.md';
import QueHacerEnTigreIt from './it/que-hacer-en-tigre.md';
import QueHacerEnTigreFr from './fr/que-hacer-en-tigre.md';

import Top5BuenosAiresEn from './en/top5-buenos-aires.md';
import Top5BuenosAiresEs from './es/top5-buenos-aires.md';
import Top5BuenosAiresDe from './de/top5-buenos-aires.md';
import Top5BuenosAiresIt from './it/top5-buenos-aires.md';
import Top5BuenosAiresFr from './fr/top5-buenos-aires.md';

import BuenosAiresAlAireLibreEn from './en/buenos-aires-al-aire-libre.md';
import BuenosAiresAlAireLibreEs from './es/buenos-aires-al-aire-libre.md';
import BuenosAiresAlAireLibreDe from './de/buenos-aires-al-aire-libre.md';
import BuenosAiresAlAireLibreIt from './it/buenos-aires-al-aire-libre.md';
import BuenosAiresAlAireLibreFr from './fr/buenos-aires-al-aire-libre.md';

import QueHacerEnLaBocaEn from './en/que-hacer-en-la-boca.md';
import QueHacerEnLaBocaEs from './es/que-hacer-en-la-boca.md';
import QueHacerEnLaBocaDe from './de/que-hacer-en-la-boca.md';
import QueHacerEnLaBocaIt from './it/que-hacer-en-la-boca.md';
import QueHacerEnLaBocaFr from './fr/que-hacer-en-la-boca.md';

import QueHacerEnPalermoEn from './en/que-hacer-en-palermo.md';
import QueHacerEnPalermoEs from './es/que-hacer-en-palermo.md';
import QueHacerEnPalermoDe from './de/que-hacer-en-palermo.md';
import QueHacerEnPalermoIt from './it/que-hacer-en-palermo.md';
import QueHacerEnPalermoFr from './fr/que-hacer-en-palermo.md';

import QueHacerEnRecoletaEn from './en/que-hacer-en-recoleta.md';
import QueHacerEnRecoletaEs from './es/que-hacer-en-recoleta.md';
import QueHacerEnRecoletaDe from './de/que-hacer-en-recoleta.md';
import QueHacerEnRecoletaIt from './it/que-hacer-en-recoleta.md';
import QueHacerEnRecoletaFr from './fr/que-hacer-en-recoleta.md';

import QueHacerEnSanTelmoEn from './en/que-hacer-en-san-telmo.md';
import QueHacerEnSanTelmoEs from './es/que-hacer-en-san-telmo.md';
import QueHacerEnSanTelmoDe from './de/que-hacer-en-san-telmo.md';
import QueHacerEnSanTelmoIt from './it/que-hacer-en-san-telmo.md';
import QueHacerEnSanTelmoFr from './fr/que-hacer-en-san-telmo.md';

import BaresNotablesDeBuenosAiresEn from './en/bares-notables-de-buenos-aires.md';
import BaresNotablesDeBuenosAiresEs from './es/bares-notables-de-buenos-aires.md';
import BaresNotablesDeBuenosAiresDe from './de/bares-notables-de-buenos-aires.md';
import BaresNotablesDeBuenosAiresIt from './it/bares-notables-de-buenos-aires.md';
import BaresNotablesDeBuenosAiresFr from './fr/bares-notables-de-buenos-aires.md';

import BarrioChinoEn from './en/barrio-chino.md';
import BarrioChinoEs from './es/barrio-chino.md';
import BarrioChinoDe from './de/barrio-chino.md';
import BarrioChinoIt from './it/barrio-chino.md';
import BarrioChinoFr from './fr/barrio-chino.md';

import ElAteneoEn from './en/el-ateneo.md';
import ElAteneoEs from './es/el-ateneo.md';
import ElAteneoDe from './de/el-ateneo.md';
import ElAteneoIt from './it/el-ateneo.md';
import ElAteneoFr from './fr/el-ateneo.md';

export const PostsDataArray = [
    {
        id: 'que-hacer-en-tigre',
        route: 'argentina/buenos-aires/barrios/que-hacer-en-tigre',
        title: {
            en: 'What to Do in Tigre',
            es: 'Qué Hacer En Tigre',
            de: 'Was Man In Tigre Unternehmen Kann',
            it: 'Che Fare A Tigre',
            fr: 'Que Faire A Tigre',
        },
        description: {
            en: 'Discover the best activities and attractions in Tigre, from nature trails to cultural landmarks.',
            es: 'Descubre las mejores actividades y atracciones en Tigre, desde senderos naturales hasta monumentos culturales.',
            de: 'Entdecken Sie die besten Aktivitäten und Sehenswürdigkeiten in Tigre, von Naturspaziergängen bis zu kulturellen Landmarken.',
            it: 'Scopri le migliori attività e attrattive in Tigre, dalle passeggiate in natura ai monumenti culturali.',
            fr: 'Découvrez les meilleures activités et attractions de Tigre, des sentiers naturels aux monuments culturels.',
        },
        image: 'que-hacer-en-tigre/portada.jpg',
        date: {
            en: 'December 08, 2025',
            es: '08 de diciembre de 2025',
            de: '08. Dezember 2025',
            it: '08 dicembre 2025',
            fr: '08 décembre 2025',
        },
        categories: [
            'escapadas',
            'barrios', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: QueHacerEnTigreEn,
            es: QueHacerEnTigreEs,
            de: QueHacerEnTigreDe,
            it: QueHacerEnTigreIt,
            fr: QueHacerEnTigreFr,
        },
    },
    {
        id: 'top5-buenos-aires',
        route: 'argentina/buenos-aires/top5-buenos-aires',
        title: {
            en: 'Top 5 Buenos Aires',
            es: 'Top 5 Buenos Aires',
            de: 'Top 5 Buenos Aires',
            it: 'Top 5 Buenos Aires',
            fr: 'Top 5 Buenos Aires',
        },
        description: {
            en: 'Discover the top 5 must-see destinations in Buenos Aires, from historic landmarks to vibrant neighborhoods.',
            es: 'Descubre los 5 destinos imperdibles de Buenos Aires, desde monumentos históricos hasta barrios vibrantes.',
            de: 'Entdecken Sie die Top 5 Sehenswürdigkeiten in Buenos Aires, von historischen Wahrzeichen bis hin zu pulsierenden Vierteln.',
            it: 'Scopri le 5 destinazioni imperdibili di Buenos Aires, dai monumenti storici ai quartieri vibranti.',
            fr: 'Découvrez les 5 destinations incontournables de Buenos Aires, des monuments historiques aux quartiers vibrants.',
        },
        image: null,
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'actividades', // Only the leaf category ID
        ],
        featured: false,
        content: {
            en: Top5BuenosAiresEn,
            es: Top5BuenosAiresEs,
            de: Top5BuenosAiresDe,
            it: Top5BuenosAiresIt,
            fr: Top5BuenosAiresFr,
        },
    },
    {
        id: 'buenos-aires-al-aire-libre',
        route: 'argentina/buenos-aires/actividades/buenos-aires-al-aire-libre',
        title: {
            en: 'Best Outdoor Places to Visit and Enjoy Nature in the City (Updated)',
            es: 'Lugares para Visitar y Disfrutar la Naturaleza en la Ciudad (Actualizado)',
            de: 'Orte zum Besuchen und Genießen der Natur in der Stadt (Aktualisiert)',
            it: 'I Migliori Luoghi All Aperto da Visitare e Godersi la Natura in Città (Aggiornato)',
            fr: 'Meilleurs Endroits en Plein Air à Visiter et à Profiter de la Nature en Ville (Mis à Jour)',
        },
        description: {
            en: 'Discover the best outdoor spots in Buenos Aires: Palermo Woods, nature reserves, and parks. Complete guide with maps and tips for walking tours.',
            es: 'Descubrí los mejores lugares al aire libre en Buenos Aires: Bosques de Palermo, reservas naturales y paseos gratuitos. Guía completa con mapas y consejos.',
            de: 'Entdecken Sie die besten Outdoor-Plätze in Buenos Aires: Palermo-Wälder, Naturschutzgebiete und Parks. Kompletter Guide mit Karten und Tipps.',
            fr: 'Découvrez les meilleurs endroits en plein air à Buenos Aires : Bosques de Palermo, réserves et parcs. Guide complet avec cartes et conseils de visite.',
            it: "Scopri i migliori posti all'aperto a Buenos Aires: Boschi di Palermo, riserve naturali e parchi. Guida completa con mappe e consigli per le visite.",
        },
        image: 'buenos-aires-al-aire-libre/obelisco-buenos-aires-letras-ba.jpg',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'actividades', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: BuenosAiresAlAireLibreEn,
            es: BuenosAiresAlAireLibreEs,
            de: BuenosAiresAlAireLibreDe,
            it: BuenosAiresAlAireLibreIt,
            fr: BuenosAiresAlAireLibreFr,
        },
    },
    {
        id: 'que-hacer-en-la-boca',
        route: 'argentina/buenos-aires/barrios/que-hacer-en-la-boca',
        title: {
            en: 'What to Do in La Boca Buenos Aires (Complete and Updated Guide)',
            es: 'Qué hacer en La Boca Buenos Aires (guía completa y actualizada)',
            de: 'Was man in La Boca Buenos Aires unternehmen kann (vollständiger und aktualisierter Reiseführer)',
            it: 'Cosa fare a La Boca Buenos Aires (Guida Completa e Aggiornata)',
            fr: 'Que faire à La Boca Buenos Aires (Guide Complet et Mis à Jour)',
        },
        description: {
            en: "Discover the best things to do in La Boca: Caminito street, La Bombonera stadium, and safety tips. Complete guide to Buenos Aires' most colorful neighborhood.",
            es: 'Descubrí qué hacer en La Boca: Caminito, La Bombonera y museos. Guía completa con mapa, consejos de seguridad y dónde comer en Buenos Aires.',
            de: "Entdecken Sie La Boca: Caminito, La Bombonera und Museen. Ein kompletter Reiseführer mit Sicherheitstipps für Buenos Aires' buntes Viertel.",
            fr: 'Découvrez les meilleures activités à La Boca : Caminito, La Bombonera et musées. Guide complet avec conseils de sécurité pour visiter ce quartier coloré.',
            it: 'Scopri cosa vedere a La Boca: il Caminito, la Bombonera e i musei. Guida turistica con consigli sulla sicurezza e dove mangiare a Buenos Aires.',
        },
        image: 'que-hacer-en-la-boca/portada.webp',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'barrios', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: QueHacerEnLaBocaEn,
            es: QueHacerEnLaBocaEs,
            de: QueHacerEnLaBocaDe,
            it: QueHacerEnLaBocaIt,
            fr: QueHacerEnLaBocaFr,
        },
    },
    {
        id: 'que-hacer-en-palermo',
        route: 'argentina/buenos-aires/barrios/que-hacer-en-palermo',
        title: {
            en: 'What to Do in Palermo Buenos Aires (Complete Guide)',
            es: 'Qué hacer en Palermo Buenos Aires (guía completa)',
            de: 'Was man in Palermo Buenos Aires unternehmen kann (vollständiger Reiseführer)',
            it: 'Cosa fare a Palermo Buenos Aires (Guida Completa)',
            fr: 'Que faire à Palermo Buenos Aires (Guide Complet)',
        },
        description: {
            en: 'Discover the best things to do in Palermo: Soho, Hollywood, Parks, and MALBA. 2026 Guide with maps, top restaurants, and hotels in Buenos Aires.',
            es: 'Descubrí qué hacer en Palermo: Bosques, Soho, Hollywood y el MALBA. Guía completa 2026 con mapas, dónde comer y los mejores hoteles de Buenos Aires.',
            de: 'Entdecken Sie Palermo: Soho, Hollywood, Parks und MALBA. Reiseführer 2026 mit Karten, Restaurants und den besten Hotels in Buenos Aires.',
            fr: 'Découvrez les meilleures activités à Palermo : Soho, Hollywood, parcs et musées. Guide 2026 avec cartes, restaurants et hôtels à Buenos Aires.',
            it: 'Scopri cosa vedere a Palermo: Soho, Hollywood, parchi e musei. Guida 2026 con mappe, ristoranti e i migliori hotel di Buenos Aires.',
        },
        image: 'que-hacer-en-palermo/portada.jpg',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'barrios', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: QueHacerEnPalermoEn,
            es: QueHacerEnPalermoEs,
            de: QueHacerEnPalermoDe,
            it: QueHacerEnPalermoIt,
            fr: QueHacerEnPalermoFr,
        },
    },
    {
        id: 'que-hacer-en-recoleta',
        route: 'argentina/buenos-aires/barrios/que-hacer-en-recoleta',
        title: {
            en: 'What to Do in Recoleta Buenos Aires: Complete Guide to Visit (Updated 2026)',
            es: 'Qué hacer en Recoleta Buenos Aires: guía completa para visitar (actualizado 2026)',
            de: 'Was man in Recoleta Buenos Aires unternehmen kann (vollständiger Reiseführer, aktualisiert 2026)',
            it: 'Cosa fare a Recoleta Buenos Aires: Guida Completa per Visitare (Aggiornato 2026)',
            fr: 'Que faire à Recoleta Buenos Aires : Guide Complet pour Visiter (Mis à Jour 2026)',
        },
        description: {
            en: 'Discover the best things to do in Recoleta: The Cemetery, Plaza Francia, and El Ateneo. 2026 Guide with maps, safety tips, and walking tours in Buenos Aires.',
            es: 'Descubrí los mejores lugares de Recoleta: el Cementerio, Plaza Francia y museos. Guía actualizada 2026 con mapa, consejos de seguridad y recorrido a pie.',
            de: 'Entdecken Sie Recoleta: Der Friedhof, Plaza Francia und Museen. Reiseführer 2026 mit Karten, Sicherheitstipps und den besten Orten in Buenos Aires.',
            fr: 'Découvrez les meilleures activités à Recoleta : le Cimetière, Plaza Francia et musées. Guide 2026 avec cartes, conseils de sécurité et visites à Buenos Aires.',
            it: 'Scopri cosa vedere a Recoleta: il Cimitero, Plaza Francia e i musei. Guida 2026 con mappe, consigli sulla sicurezza e itinerari a Buenos Aires.',
        },
        image: 'que-hacer-en-recoleta/portada.jpg',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'barrios', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: QueHacerEnRecoletaEn,
            es: QueHacerEnRecoletaEs,
            de: QueHacerEnRecoletaDe,
            it: QueHacerEnRecoletaIt,
            fr: QueHacerEnRecoletaFr,
        },
    },
    {
        id: 'que-hacer-en-san-telmo',
        route: 'argentina/buenos-aires/barrios/que-hacer-en-san-telmo',
        title: {
            en: 'What to Do in San Telmo Buenos Aires: Complete Guide',
            es: 'Qué hacer en San Telmo Buenos Aires: guía completa',
            de: 'Was man in San Telmo Buenos Aires unternehmen kann: vollständiger Reiseführer',
            it: 'Cosa fare a San Telmo Buenos Aires: Guida Completa',
            fr: 'Que faire à San Telmo Buenos Aires : Guide Complet',
        },
        description: {
            en: 'Discover the best things to do in San Telmo: The Market, Plaza Dorrego, and the Antique Fair. 2026 Guide with maps, safety tips, and tango spots in Buenos Aires.',
            es: 'Descubrí qué hacer en San Telmo: Mercado, Plaza Dorrego, museos y la feria de antigüedades. Guía 2026 con mapa, seguridad, dónde comer y tango.',
            de: 'Entdecken Sie San Telmo: Markt, Plaza Dorrego und Antiquitätenmesse. Reiseführer 2026 mit Karten, Sicherheitstipps und den besten Tango-Orten in Buenos Aires.',
            fr: 'Découvrez les meilleures activités à San Telmo : le Marché, Plaza Dorrego et la foire aux antiquités. Guide 2026 avec cartes, sécurité et tango à Buenos Aires.',
            it: "Scopri cosa vedere a San Telmo: il Mercato, Plaza Dorrego e la fiera dell'antiquariato. Guida 2026 con mappe, consigli sulla sicurezza e tango a Buenos Aires.",
        },
        image: 'que-hacer-en-san-telmo/portada.jpg',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'barrios', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: QueHacerEnSanTelmoEn,
            es: QueHacerEnSanTelmoEs,
            de: QueHacerEnSanTelmoDe,
            it: QueHacerEnSanTelmoIt,
            fr: QueHacerEnSanTelmoFr,
        },
    },
    {
        id: 'bares-notables-de-buenos-aires',
        route: 'argentina/buenos-aires/bares-notables-de-buenos-aires',
        title: {
            en: 'Complete Guide to the Best Cafés and Bars in Buenos Aires (Updated 2026)',
            es: 'Guía Definitiva de los Bares Notables: Cafés y Bares Históricos de Buenos Aires (Actualizado 2026)',
            de: 'Vollständiger Reiseführer zu den besten Cafés und Bars in Buenos Aires (Aktualisiert 2026)',
            it: 'Guida Completa ai migliori cafés e bar in Buenos Aires (Aggiornato 2026)',
            fr: 'Guide Complet aux meilleurs cafés et bars à Buenos Aires (Mis à Jour 2026)',
        },
        description: {
            en: 'Discover the best cafes and bars in Buenos Aires: Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos. 2026 Guide with maps, top restaurants, and hotels in Buenos Aires.',
            es: 'Descubrí los mejores cafés y bares de Buenos Aires: Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos. Guía 2026 con mapas, dónde comer y los mejores hoteles de Buenos Aires.',
            de: 'Entdecken Sie die besten Cafés und Bars in Buenos Aires: Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos. Reiseführer 2026 mit Karten, Restaurants und den besten Hotels in Buenos Aires.',
            fr: 'Découvrez les meilleurs cafés et bars à Buenos Aires: Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos. Guide 2026 avec cartes, restaurants et hôtels à Buenos Aires.',
            it: 'Scopri i migliori cafés e bar in Buenos Aires: Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos, Café Tortoni, Café de los Angelitos. Guida 2026 con mappe, ristoranti e i migliori hotel di Buenos Aires.',
        },
        image: 'bares-notables-de-buenos-aires/bar-sur-extra.webp',
        date: {
            en: 'December 10, 2025',
            es: '10 de diciembre de 2025',
            de: '10. Dezember 2025',
            it: '10 dicembre 2025',
            fr: '10 décembre 2025',
        },
        categories: [
            'cafes', // Only the leaf category ID
        ],
        featured: true,
        content: {
            en: BaresNotablesDeBuenosAiresEn,
            es: BaresNotablesDeBuenosAiresEs,
            de: BaresNotablesDeBuenosAiresDe,
            it: BaresNotablesDeBuenosAiresIt,
            fr: BaresNotablesDeBuenosAiresFr,
        },
    },
    {
        id: 'barrio-chino',
        route: 'argentina/buenos-aires/actividades/barrio-chino',
        title: {
            en: 'What to Do in Barrio Chino Buenos Aires: Complete Guide (Updated 2026)',
            es: 'Qué hacer en Barrio Chino Buenos Aires: guía completa (actualizado 2026)',
            de: 'Was man in Barrio Chino Buenos Aires unternehmen kann: vollständiger Reiseführer (aktualisiert 2026)',
            it: 'Cosa fare a Barrio Chino Buenos Aires: Guida Completa (aggiornato 2026)',
            fr: 'Que faire à Barrio Chino Buenos Aires : Guide Complet (mis à jour 2026)',
        },
        description: {
            en: 'Discover the best things to do in Barrio Chino: The Market, Plaza Dorrego, and the Antique Fair. 2026 Guide with maps, safety tips, and tango spots in Buenos Aires.',
            es: 'Descubrí qué hacer en Barrio Chino: Mercado, Plaza Dorrego, museos y la feria de antigüedades. Guía actualizada 2026 con mapa, seguridad, dónde comer y tango.',
            de: 'Entdecken Sie Barrio Chino: Markt, Plaza Dorrego und Antiquitätenmesse. Reiseführer aktualisiert 2026 mit Karten, Sicherheitstipps und den besten Tango-Orten in Buenos Aires.',
            fr: 'Découvrez les meilleures activités à Barrio Chino : le Marché, Plaza Dorrego et la foire aux antiquités. Guide mis à jour 2026 avec cartes, sécurité et tango à Buenos Aires.',
            it: "Scopri cosa vedere a Barrio Chino: il Mercato, Plaza Dorrego e la fiera dell'antiquariato. Guida aggiornata 2026 con mappe, consigli sulla sicurezza e tango a Buenos Aires.",
        },
        image: 'barrio-chino/entrada.jpg',
        date: {
            en: 'December 21 2025',
            es: '21 de diciembre de 2025',
            de: '21. Dezember 2025',
            it: '21 dicembre 2025',
            fr: '21 décembre 2025',
        },
        categories: ['actividades'],
        featured: true,
        content: {
            en: BarrioChinoEn,
            es: BarrioChinoEs,
            de: BarrioChinoDe,
            it: BarrioChinoIt,
            fr: BarrioChinoFr,
        },
    },
    {
        id: 'el-ateneo',
        route: 'argentina/buenos-aires/actividades/el-ateneo',
        title: {
            en: 'Visit the Most Beautiful Library in the World: El Ateneo Grand Splendid Buenos Aires',
            es: 'El Ateneo Grand Splendid de Buenos Aires: Guía para Visitar la Librería Más Espectacular del Mundo',
            de: 'Besuchen Sie das Schönste Bibliothek der Welt: El Ateneo Grand Splendid Buenos Aires',
            it: 'Visita la Biblioteca Più Bella del Mondo: El Ateneo Grand Splendid Buenos Aires',
            fr: 'Visitez la Bibliothèque la Plus Belle du Monde: El Ateneo Grand Splendid Buenos Aires',
        },
        description: {
            en: 'Discover the most beautiful library in the world: El Ateneo Grand Splendid Buenos Aires. Complete guide with maps, safety tips, and walking tours in Buenos Aires.',
            es: 'Descubre la librería más bella del mundo: El Ateneo Grand Splendid de Buenos Aires. Guía completa con mapas, seguridad, dónde comer y recorrido a pie.',
            de: 'Entdecken Sie die schönste Bibliothek der Welt: El Ateneo Grand Splendid Buenos Aires. Reiseführer mit Karten, Sicherheitstipps und den besten Orten in Buenos Aires.',
            fr: 'Découvrez la bibliothèque la plus belle du monde: El Ateneo Grand Splendid Buenos Aires. Guide complet avec cartes, sécurité et visites à Buenos Aires.',
            it: 'Scopri la biblioteca più bella del mondo: El Ateneo Grand Splendid Buenos Aires. Guida completa con mappe, consigli sulla sicurezza e itinerari a Buenos Aires.',
        },
        image: 'el-ateneo/el-ateneo.webp',
        date: {
            en: 'December 21 2025',
            es: '21 de diciembre de 2025',
            de: '21. Dezember 2025',
            it: '21 dicembre 2025',
            fr: '21 décembre 2025',
        },
        categories: ['actividades'],
        featured: true,
        content: {
            en: ElAteneoEn,
            es: ElAteneoEs,
            de: ElAteneoDe,
            it: ElAteneoIt,
            fr: ElAteneoFr,
        },
    },
];

export const PostsDataMap = PostsDataArray.reduce((map = {}, post) => {
    map[post.id] = post;
    return map;
}, {});

export const getPostRoutes = () => {
    return PostsDataArray.map((post) => post.route);
};
